import { render, staticRenderFns } from "./Disclosed.vue?vue&type=template&id=a7c36b20&scoped=true"
import script from "./Disclosed.vue?vue&type=script&lang=js"
export * from "./Disclosed.vue?vue&type=script&lang=js"
import style0 from "./Disclosed.vue?vue&type=style&index=0&id=a7c36b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c36b20",
  null
  
)

export default component.exports